import React, {useCallback, useContext} from 'react';
import * as PropTypes from 'prop-types';
import styles from './styles.modules.scss';
import Popover from 'ati-ui-react/components/Tip/Popover';
import Link from 'ati-ui-react/components/Link';

import PopoverButtonTemplate from 'ati-ui-react/components/Tip/PopoverButtonTemplate';
import {DataContext} from 'contexts';
import {useLocalized} from 'utils/useLocalized';
import i18nStrings from './strings';
import {helpSiteUrl, mainSiteUrl} from 'urls';

const NoBoardsPopover = ({children, visible, onVisibilityChange}) => {
    const {isMobile} =  useContext(DataContext);

    const strings = useLocalized(i18nStrings);

    const onCreateBoardsClick = useCallback(()=>{
        window.open(`${mainSiteUrl}/boards/my/add/loads`, '_blank');
    }, []);

    return (
        <div className={styles['boards-container']}>

            <Popover
                isClosedOnOutsideClick
                restorePosition
                control={(
                    <PopoverButtonTemplate
                        buttonProps={{
                            size: 'small',
                            onClick: onCreateBoardsClick
                        }}
                        buttonText={strings.createBoardHeader}
                        className="control-button"
                    />
                )}

                fixedBodyPosition={isMobile}
                isCenterAlignmentOnAdaptive={false}
                mainContent={(

                    <React.Fragment>
                        <div
                            className={styles['popover-header']}
                        >
                            <span>
                                {strings.createBoard}
                            </span>
                        </div>
                        <div className={styles['main-content']}>
                            <div>
                                {strings.boardsDescription}
                            </div>
                            <div className={styles['help-link-container']}>
                                <Link
                                    href={`${helpSiteUrl}/faq/Ploschadki.html`}
                                    target="_blank"
                                    type="external"
                                >
                                    {strings.whatIsBoards}
                                </Link>
                            </div>
                        </div>

                    </React.Fragment>
                )}
                mainContentClassName={styles['content-section']}
                placement="top"
                templateWrapperClassName={styles['popover-container']}
                visible={visible}

                onCloseClick={(event)=>onVisibilityChange(false, event)}
                onVisibilityChange={onVisibilityChange}
            >
                <div
                    onClick={() => {
                        onVisibilityChange(true);
                    }}
                >
                    {children}
                </div>
            </Popover>
        </div>

    );
};

export default NoBoardsPopover;

NoBoardsPopover.propTypes = {
    children: PropTypes.node,
    visible: PropTypes.bool,
    onVisibilityChange: PropTypes.func
};
